import { useLogsApi } from '@api/tutor-kanban/logs.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void useLogsApi({ tutorId })
})
